"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents["default"].div.attrs(function () {
  return {
    className: 'd-flex justify-content-between align-items-center'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 1rem 0 0.8rem;\n    margin-bottom: 0.8rem;\n    border-bottom: 1px solid #fff;\n\n    > * {\n        margin: 0;\n    }\n\n    .heading {\n        font-size: 1.6rem;\n        font-weight: 200;\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
});

var Heading = function Heading(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'Set heading' : _ref$name,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "heading",
    "data-testid": "page-heading"
  }, name), children);
};

var _default = Heading;
exports["default"] = _default;